import {v4 as uuid} from "uuid";
import type {Annotation, GridPoint, LevelGeometryDocument} from "@/dungeons/model/DungeonGeometry.ts";

export type AnnotationKind = Annotation["kind"];

export function createAnnotation(position: GridPoint, kind: AnnotationKind): Annotation {
    return {
        id: uuid(),
        position,
        kind,
        label: kind === "ROOM" ? "?" : null,
        title: kind === "ROOM" ? "Neuer Raum" : "Neue Notiz",
        text: null,
    };
}

export function addAnnotation(document: LevelGeometryDocument, position: GridPoint, kind: AnnotationKind) {
    const annotation = createAnnotation(position, kind);
    return {annotation, document: {...document, annotations: [...document.annotations, annotation]}};
}

export function changeAnnotation(document: LevelGeometryDocument, id: string, changes: Partial<Annotation>) {
    const current = document.annotations.find(annotation => annotation.id === id);
    if (!current || Object.entries(changes).every(([key, value]) => current[key as keyof Annotation] === value)) {
        return document;
    }
    return {...document, annotations: document.annotations.map(annotation =>
        annotation.id === id ? {...annotation, ...changes, id} : annotation)};
}

export function removeAnnotation(document: LevelGeometryDocument, id: string) {
    if (!document.annotations.some(annotation => annotation.id === id)) return document;
    return {...document, annotations: document.annotations.filter(annotation => annotation.id !== id)};
}
